export const titles = ['Legal info about the company', 'General terms and conditions'];
